<template>
  <div>
    <v-divider></v-divider>
    <v-layout wrap fill-height>
      <v-flex class="sidebar-slot">
        <AppSidebar :items="items" v-model="sideNav" />
      </v-flex>
      <v-flex class="main-content-flex">
        <v-layout wrap pb-0 mb-0>
          <v-flex xs12 sm12 md12 lg12 pb-0 mb-0>
            <AppHeader class="pb-0 mb-0" @toggle-nav="sideNav = !sideNav" />
          </v-flex>
          <v-flex xs12 pt-0 mt-0><v-divider class="pt-0 mt-0"></v-divider></v-flex>
          <v-flex xs12 sm12 md12 lg12 pl-0>
            <v-layout wrap justify-center :style="
                $route.name == 'dashboard'
                  ? 'background-color: #ffffff'
                  : 'background-color: #f6fff9'
              ">
              <v-flex xs12>
                <v-card min-height="100vh" :color="
                    $route.name == 'dashboard' ? 'transparent' : '#FFFFFF'
                  " flat>
                  <v-layout wrap justify-center>
                    <v-flex xs12>
                      <router-view :key="$route.fullPath"></router-view>
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>
  <script>
  import AppHeader from "@/components/Common/appHeadersarpa";
import AppSidebar from "@/components/Common/appSidebar";
  
  export default {
    components: {
      AppHeader,
    AppSidebar,
    },
    data() {
      return {
      //open state for the sidebar; only used below md, where it overlays
      sideNav: false,
        // items: [
        // {
        //     title: "Dashboard",
        //     icon: "mdi-view-dashboard",
        //     path: "/medicalOfficers/dmoDashboard",
        // },
        // {
        //     title: "Stock Details",
        //     icon: "mdi-medical-bag",
        //     path: "/medicalOfficers/stockVenom",
        // },
        // {
        //     title: "Victim Details",
        //     icon: "mdi-hospital-box",
        //     path: "/medicalOfficers/victimDetails",
        // },
  
        // ],

        items: [
      {
          title: "Dashboard",
          icon: "mdi-view-dashboard",
          path: "/DistrictEmergencyOfficer/districtDashboard",
        },
        // {
        //   title: "New Rescuers",
        //   icon: "mdi-account-plus",
        //   path: "/officers/newrescuerslist",
        // },
        {
          title: "Rescuer List",
          icon: "mdi-account-multiple-plus ",
          path: "/DistrictEmergencyOfficer/allrescuerlistDis",
        },
        {
          title: "DMO List",
          icon: "mdi-doctor",
          path: "/DistrictEmergencyOfficer/alldmolist",
        },
        // {
        //   title: "Pending Operations",
        //   icon: "mdi-playlist-remove",
        //   path: "/DistrictEmergencyOfficer/pendingoperations",
        // },
        // {
        //   title: "Assigned Operations",
        //   icon: "mdi-view-list",
        //   path: "/DistrictEmergencyOfficer/assignedoperations",
        // },
        // {
        //   title: "Rescued Operations",
        //   icon: "mdi-playlist-plus",
        //   path: "/DistrictEmergencyOfficer/rescuedoperations",
        // },
        // {
        //   title: "Released Operations",
        //   icon: "mdi-format-list-checks",
        //   path: "/DistrictEmergencyOfficer/releasedoperations",
        // },
        // {
        //   title: "Approved Operations",
        //   icon: "mdi-playlist-check",
        //   path: "/DistrictEmergencyOfficer/approvedoperations",
        // },
        {
          title: "Snake Reports",
          icon: "mdi-file-chart",
          path: "/DistrictEmergencyOfficer/snakereports",
        },
        {
          title: "Anti-Venom Stock",
          icon: "mdi-medical-bag",
          path: "/DistrictEmergencyOfficer/stockVenom",
        },
        {
          title: "Delete Operations",
          icon: "mdi-delete-sweep",
          path: "/DistrictEmergencyOfficer/deleteoperations",
        },
        // {
        //   title: "Control Room ",
        //   icon: "mdi-file-account",
        //   path: "/DistrictEmergencyOfficer/controlRoomList",
        // },
        // {
        //   title: "Emergency Officers",
        //   icon: "mdi-account-hard-hat",
        //   path: "/DistrictEmergencyOfficer/alldistrictlist",
        // },
        {
          title: "Snake Bite Alerts",
          icon: "mdi-bell-alert",
          path: "/DistrictEmergencyOfficer/snakebiteAlerts",
        },
        {
          title: "Snake Bite Cases",
          icon: "mdi-hospital-box-outline",
          path: "/DistrictEmergencyOfficer/snakeBiteDis",
        },
        // {
        //   title: "Fraud Cases",
        //   icon: "mdi-close-box-multiple",
        //   path: "/DistrictEmergencyOfficer/fraudcases",
        // },

      ],
        right: null,
      };
    },
  };
</script>

<style scoped>
/* reserves the column the fixed sidebar occupies from md up */
.sidebar-slot {
  flex: 0 0 0 !important;
  max-width: 0 !important;
  width: 0 !important;
}
@media (min-width: 960px) {
  .sidebar-slot {
    flex: 0 0 280px !important;
    max-width: 280px !important;
    width: 280px !important;
  }
}

.main-content-flex {
  flex: 1 1 auto !important;
  max-width: 100% !important;
  width: 100% !important;
}

@media (min-width: 960px) {
  .main-content-flex {
    max-width: calc(100% - 280px) !important;
    width: calc(100% - 280px) !important;
  }
}
</style>